import { truncateDecimalAmount, zeroDecimal } from './numberFormat';

export type BalanceToken = {
  id: string;
  label: string;
  decimals: number;
  aliases?: string[];
};

export const BALANCE_TOKENS: BalanceToken[] = [
  { id: 'GRAM', label: 'GRAM (ex. TON)', decimals: 9, aliases: ['GRAM', 'TON'] },
  { id: 'USDT', label: 'USDT', decimals: 6 },
  { id: 'EVAA', label: 'EVAA', decimals: 9 },
  { id: 'DOGS', label: 'DOGS', decimals: 9 },
  { id: 'UTYA', label: 'UTYA', decimals: 9 },
  { id: 'NOT', label: 'NOT (Notcoin)', decimals: 9 },
  { id: 'STORM', label: 'STORM', decimals: 9 },
  { id: 'REDO', label: 'REDO', decimals: 9 },
];

export function balanceTokenKeys(token: BalanceToken): string[] {
  return token.aliases ?? [token.id];
}

export function formatTokenAmount(_token: BalanceToken | string, amount: string): string {
  return truncateDecimalAmount(amount, 2, zeroDecimal(2));
}
